import leeCoreLex from 'bundles/epic/clients/leeCoreLex';

/**
 * Checks if the My Learning Redesign experiment variant is enabled.
 * This variant enables the consolidated accomplishments page redesign
 * showing a unified view of all learner achievements.
 * Experiment: https://tools.coursera.org/epic/experiment/C_KxEewYEfC-lAr_4rnFJw
 *
 * @returns True if the experimental variant is enabled, false otherwise
 */
export function isMyLearningRedesignEnabled(): boolean {
  return leeCoreLex.preview('enableMyLearningRedesign');
}

/**
 * Records an impression for the My Learning Redesign experiment.
 * Experiment: https://tools.coursera.org/epic/experiment/C_KxEewYEfC-lAr_4rnFJw
 *
 * @returns The variant that was shown to the user (true for experimental, false for control)
 */
export function impressIntoMyLearningRedesignExperiment(): boolean {
  return leeCoreLex.get('enableMyLearningRedesign');
}
